import { cn } from "../../lib/utils"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  // If animate-pulse-slow is in className, don't add animate-pulse
  const hasSlowPulse = className?.includes('animate-pulse-slow');
  return (
    <div
      className={cn(
        !hasSlowPulse && "animate-pulse",
        "rounded-md bg-gray-800",
        className
      )}
      {...props}
    />
  )
}

export { Skeleton }
